<div class="container-data form-field-density-4" [ngStyle]="!editMode? {'max-height': '200px'} : {'max-height': '350px'}">
    <div class="float-add-button" *ngIf="!editMode">
        <button nz-button nzType="primary" nzShape="circle" nz-tooltip="Adicionar" (click)="novo()">
            <nz-icon nzType="plus"></nz-icon>
        </button>
    </div>
    <div class="edit-view" *ngIf="editMode">
        <nz-spin [nzSpinning]="actionLoading" nzSize="large">
        <div class="actions-toolbar">
            <button nz-button nzType="primary" nzShape="circle" nz-tooltip="Salvar" (click)="salvar()">
                <nz-icon nzType="check"></nz-icon>
            </button>
            <span class="span1"></span>
            <button nz-button nzType="primary" nzDanger nzShape="circle" nz-tooltip="Cancelar" (click)="cancelEdit()">
                <nz-icon nzType="close"></nz-icon>
            </button>
            <span class="span1"></span>
            <nz-divider nzType="vertical"></nz-divider>

            <div class="fields">
                <search-input  entityname="Mktpcontract"  entitydesc="Contrato" [form]="formAction" controlname="CODECONTRACT" placeholder="Contrato" columnname="CODECONTRACT" class="no-padding-form-field" [loaddesc]="true" columndesc="Contrato" fieldname="CONTRACTNAME" (onchange)="onChange($event)" >
                </search-input>
                <span class="span1"></span>
                <search-input  entityname="Mktpcompanies"  entitydesc="Empresa" [form]="formAction" controlname="CODECOMPANY" placeholder="Empresa" columnname="CODECOMPANY" class="no-padding-form-field" [loaddesc]="true" [condition]="condition" [required]="false">
                </search-input>
            </div>
        </div>
        <div class="container-formula-tester">
            <div class="tem-field">
                <div class="tem-field-label-row">
                    <label class="tem-field-label">Formula<span class="tem-field-required"> *</span></label>
                    <button tabindex="-1" type="button" nz-button nzType="text" nzSize="small" aria-label="Executar" (click)="openEditFormula()" nz-tooltip="Executar">
                        <nz-icon nzType="thunderbolt"></nz-icon>
                    </button>
                </div>
                <textarea nz-input required [(ngModel)]="formula" [nzAutosize]="{ minRows: 4, maxRows: 10 }"></textarea>
            </div>
        </div>
        </nz-spin>
    </div>
    <div class="grid-view" *ngIf="!editMode">
        <nz-spin [nzSpinning]="actionLoading" nzSize="large">
        <div class="props-grid props-grid-actions props-grid-header">
            <div class="info-title">Empresa</div>
            <div class="info-title">Expressão</div>
            <div class="info-title">Ações</div>
        </div>
        <div class="props-grid props-grid-actions" *ngFor="let item of data | async">
            <div class="info-desc" [nz-tooltip]="item.COMPANY">{{item.COMPANY}}</div>
            <div class="info-desc" [nz-tooltip]="item.TEXT">{{item.TEXT}}</div>
            <div class="info-desc">
                <button nz-button nzType="text" nzShape="circle" nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click" aria-label="Ações do item">
                    <nz-icon nzType="more"></nz-icon>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                    <ul nz-menu>
                        <li nz-menu-item (click)="selectItem($event,item)">
                            <nz-icon nzType="edit"></nz-icon>
                            <span class="menu-label">Editar</span>
                        </li>
                        <li nz-menu-item (click)="deleteItem($event,item)">
                            <nz-icon nzType="delete"></nz-icon>
                            <span class="menu-label">Excluir</span>
                        </li>
                        <li nz-menu-item (click)="duplicate($event,item)">
                            <nz-icon nzType="copy"></nz-icon>
                            <span class="menu-label">Duplicar</span>
                        </li>
                        <li nz-menu-item (click)="showParameters($event,item)" *ngIf="showParameter">
                            <nz-icon nzType="setting"></nz-icon>
                            <span class="menu-label">Parâmetros</span>
                        </li>
                    </ul>
                </nz-dropdown-menu>
            </div>
        </div>
        </nz-spin>
    </div>

</div>
